export default {
  setParametros(state, payload) {
    state.parametros = payload
  }
}
